<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters,mapActions,mapState } from "vuex"
import axios from 'axios';
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Sales",
    meta: [
        {
          name: "description",
          content: appConfig.description,
        },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    ModelListSelect,
  },
  data() {
    return {
      total_amount: 0,
      total_paid: 0,
      total_discount: 0,
      total_balance: 0,
      filterSales:{
        customer: atob(this.$route.params.id),
        product: '',
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "CUSTOMER SALES PROFILE",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "CUSTOMER SALES PROFILE",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      ReturnedSales: [],
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "details",
          sortable: true,
          label: 'DETAILS',
        },
        {
          key: "totalAmt",
          sortable: true,
          label: 'TOTAL',
        },
        {
          key: "totalPaid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "discount",
          sortable: true,
          label: "DISCOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
        {
          key: "addedon",
          sortable: true,
          label: "DATE",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // delete unit
      reorderData: {
        id: "",
      },
    };
  },
  computed: {
         // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
      ]),
    ...mapGetters("customers", ["CustomerSales",'SaveStatus']),
    ...mapGetters("products", ["Products"]),
    ...mapGetters("auth", ["business","branch"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.CustomerSales ? this.CustomerSales.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.CustomerSales ? this.CustomerSales.length : 1;
  },  
  methods: {
    ...mapActions({
      FetchProducts: "products/fetchProducts",
      FetchSales: "customers/fetchCustomerSales", 
      ReorderSale: "customers/reorderSale", 
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    SalesReportData() {
      this.FetchSales(this.filterSales);
    },
    showReorderModal(val) {
      // alert(val);
      this.reorderData.id = val;
    },
    reorderSale(modalId) {
      this.modal_id = modalId;
      this.ReorderSale(this.reorderData);
    },
    goToNesSale() {
      this.$router.push(
        `/sales/order`
      );
    },
    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    Excel_export() {
      axios
        .post("export_basicsales", this.filterSales,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "export_customer_profile.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    }, 
  },
  updated() {
    let total_amount = 0;
      let total_paid = 0;
      let total_discount = 0;
      let total_balance = 0;
      if(this.CustomerSales){
        this.CustomerSales.forEach((item)=>{
          total_amount = total_amount+parseInt(item.totalAmt);
          total_paid = total_paid+parseInt(item.totalPaid);
          total_discount = total_discount+parseInt(item.discount);
          total_balance = total_balance+parseInt(item.balance);
        });
        this.total_amount = total_amount;
        this.total_paid = total_paid;
        this.total_discount = total_discount;
        this.total_balance = total_balance;
      }
  },
  watch: {
    Sales(newValue){
      if(newValue == true){
        this.SalesReportData();
      }
    },
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          // this.resetAdd();
        // this.resetError();
          Swal.fire("Success!", this.message.msg, "success");
          this.goToNesSale();
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  created() {
    this.FetchProducts();
    this.FetchSales(this.filterSales);
  },
};
</script>

<template>
  <Layout>
    <h4 class="text-center text-primary">{{business}} - {{branch}}</h4>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center text-uppercase">CUSTOMER SALES PROFILE FOR {{ CustomerSales[0].customerobj.name }}</h3>
              </div>
              <div class="col-md-3">
                <b-button variant="info" @click="Excel_export()"
                  ><i class="fa fa-file-excel"></i>Export</b-button>
              </div>
            </div>
            <div class="row">       
                <div class="col-md-9"></div>       
              <div class="col-md-3 form-group">
                <label>PRODUCT</label>
                
                <model-list-select
                  :list="Products ? Products : []"
                  v-model="filterSales.product"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Product"
                  @input="SalesReportData()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="CustomerSales?CustomerSales:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template> 
                <template #cell(totalAmt)="data">
                  {{ thousandSeperator(data.item.totalAmt) }}
                </template>
                <template #cell(totalPaid)="data">
                  {{ thousandSeperator(data.item.totalPaid) }}
                </template>
                <template #cell(discount)="data">
                  {{ thousandSeperator(data.item.discount) }}
                </template>
                <template #cell(balance)="data">
                  {{ thousandSeperator(data.item.balance) }}
                </template>
                <template #cell(details)="data">
                  <table class="table">
                    <thead v-if="data.index == 0">
                      <tr>
                        <th width="50%">Item</th>
                        <th width="10%">Qty</th>
                        <th width="15%">Price</th>
                        <th width="15%">Total</th>
                      </tr>
                    </thead>
                    <thead v-else></thead>
                    <tbody>
                      <tr v-for="(sale, s) in data.item.items" :key="s">
                        <td width="50%">{{ sale.product }}</td>
                        <td width="10%">{{ sale.qty }}</td>
                        <td width="15%">{{ thousandSeperator(sale.SPrice) }}</td>
                        <td width="15%">
                          {{ thousandSeperator(sale.SPrice * sale.qty) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template> 
                <template #cell(actions)="data">
                       
                  <b-button
                      size="sm"
                      variant="primary"
                      class="m-2"
                      v-b-modal.reorder-product-modal
                      @click="showReorderModal(data.item.id)"
                  ><i class="fa fa-check"></i> Reorder</b-button
                  >
                  
                </template>       
              </b-table>
              <div class="row">
                  <div class="col-md-3">
                    <h5>Total Amount: <span class="text-danger">{{(total_amount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Paid: <span class="text-danger">{{(total_paid).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Discount: <span class="text-danger">{{(total_discount).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-3">
                    <h5>Total Balance: <span class="text-danger">{{(total_balance).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader  v-if="!CustomerSales"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!-- modal delete product starts -->
     <b-modal
        header-bg-variant="success"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="success"
        footer-text-variant="success"
        id="reorder-product-modal"
        hide-footer
    >
      <template #modal-title> Reorder This Sale</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to Re-order this Sale? Click Proceed Button to Re-order.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('reorder-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-success"
            @click="reorderSale('reorder-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Reordering"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>

  
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
